import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { EmptyState } from './empty-state';
import { Icon } from './icon';

/** Failed-load message with a retry action; use inside panels in place of their content. */
export function ErrorState({ message, onRetry }: { message?: string; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <EmptyState
      tone="bad"
      icon="alert"
      title={t('states.errorTitle')}
      description={message ?? t('states.errorHint')}
      action={
        onRetry && (
          <Button size="small" onClick={onRetry} startIcon={<Icon name="repeat" size={16} />}>
            {t('actions.retry')}
          </Button>
        )
      }
    />
  );
}
